import { useNavigate } from "react-router-dom";
import { resendRecieverRejectedExpense } from "../../apiEndpoints";
import Modal from "../../../../components/portal/Modal";
import ErrorDisplay from "../../../../components/UI/ErrorDisplay";
import successIcon from "../../../../assets/icons/successIcon.svg";
import GradientButton from "../../../../components/UI/buttonUI/GradientButton";
import GrayButton from "../../../../components/UI/buttonUI/GrayButton";
import usePostData from "../../../../CustomHooks/useAxios/usePostData";

export const ResendExpense = ({ setResendDialog, resendDetails }) => {
  const { executePost, loading, successResponse, formError, setFormError } =
    usePostData();
  const navigate = useNavigate();
  const { id, amount, receiver, category } = resendDetails;

  const resendExpense = () => {
    executePost(() => { }, resendRecieverRejectedExpense(id));
  };

  const closeDialog = () => setResendDialog({ isOpen: false, data: null });

  return (
    <Modal
      onClose={loading || successResponse ? undefined : closeDialog}
      modalWidth="w-11/12 max-sm:w-[95%] max-md:p-4 py-7 px-6 max-w-sm"
    >
      <>
        {successResponse ? (
          <div className="text-center">
            <img src={successIcon} alt="success" className="mx-auto w-9 mb-2" />
            <p className="py-5"> Expense resent successfully.</p>
            <GradientButton
              btnText="Ok"
              width="w-26"
              onClick={() => navigate(0)}
            />
          </div>
        ) : (
          <>
            {formError && (
              <ErrorDisplay
                message={formError}
                closeAction={() => setFormError("")}
              />
            )}
            <p className="text-md font-medium text-center mb-4">
              Do you want to resend this expense?
            </p>

            <div className="rounded-lg border border-gray-200 divide-y divide-gray-200 mb-3">
              <div className="flex items-center justify-between px-3 py-2">
                <span className="text-gray-500 text-sm">Resend to</span>
                <span className="font-semibold text-black text-sm">
                  {receiver}
                </span>
              </div>
              <div className="flex items-center justify-between px-3 py-2">
                <span className="text-gray-500 text-sm">Amount</span>
                <span className="font-semibold text-black text-sm">
                  ₹{amount}
                </span>
              </div>
              <div className="flex items-center justify-between px-3 py-2">
                <span className="text-gray-500 text-sm">Category</span>
                <span className="font-semibold text-black text-sm">
                  {category}
                </span>
              </div>
            </div>

            <div className="flex gap-2 rounded-md bg-amber-50 border border-amber-200 px-3 py-2 mb-4">
              <span className="text-amber-500 text-sm leading-5">ⓘ</span>
              <p className="text-amber-800 text-xs leading-5">
                This expense is a replica of the original. Via {category} money sent to {receiver} for approval.
              </p>
            </div>

            {/* Buttons */}
            <div className="flex justify-end gap-2">
              <GrayButton
                onClick={closeDialog}
                btnText="Cancel"
                disabled={loading}
              />
              <button
                onClick={resendExpense}
                className="bg-emerald-100 hover:bg-emerald-50 text-emerald-600 transition-all px-3 py-1 rounded-md"
                disabled={loading}
              >
                {loading ? "Resending..." : "Resend"}
              </button>
            </div>
          </>
        )}
      </>
    </Modal>
  );
};
